import { P } from '@fabric-app/ui/components/Typography';
import { styled } from 'styled-components';

const ResourcePreviewTitle = styled(P).attrs((props) => {
  return {
    weight: 600,
    size: "sm",
    color: "tertiary",
    ellipsis: true,
    as: "div",
    ...props
  };
}).withConfig({
  displayName: "Typography__ResourcePreviewTitle",
  componentId: "sc-26143be9-0"
})([
  `flex-shrink:0;`
]);
const ResourcePreviewDescription = styled(P).attrs((props) => {
  return {
    size: "xxs",
    color: "quaternary",
    ellipsis: true,
    ...props
  };
}).withConfig({
  displayName: "Typography__ResourcePreviewDescription",
  componentId: "sc-26143be9-1"
})([
  `flex-shrink:0;`
]);

export { ResourcePreviewDescription, ResourcePreviewTitle };
//# sourceMappingURL=Typography.js.map
